/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
window.PXUTheme.jsAjaxCart = {
  init: function ($section) {

    // Add settings from schema to current object
    window.PXUTheme.jsAjaxCart = $.extend(this, window.PXUTheme.getSectionData($section));
    //console.log('Init Function Called');
    if (isScreenSizeLarge() || this.cart_action == 'drawer') {
      this.initializeAjaxCart();
    } else {
      // this.initializeAjaxCartOnMobile();
    }

    if (this.cart_action == 'drawer') {

      this.ajaxCartDrawer = $('[data-ajax-cart-drawer]');
      $(document).on('click', '[data-ajax-cart-trigger]', function (e) {
        e.preventDefault();
        window.PXUTheme.jsAjaxCart.showDrawer();

        return false;
      });

      if (!$('body').hasClass('atc-user-activate')) {
        const rewardSections = document.querySelectorAll(".discount-reward-bar");
        rewardSections.forEach(rewardSection => {
          rewardSection.style.display = 'none';
        });

        // Remove the custom cart drawer section if it exists
      /*  console.log("Removing reward sections for non-ATC user");
        const drawerSections = document.querySelectorAll(".custom-cart-rewards-bar");
        drawerSections.forEach(drawerSection => {
          drawerSection.style.display = "none";
        });*/
        const cartWrapers = document.querySelectorAll(".theme-ajax-cart");
        cartWrapers.forEach(cartWraper => {
          if(cartWraper && !cartWraper.classList.contains('drawer-without-reward')){
              cartWraper.classList.add('drawer-without-reward');
            } 
        });
      } else {
        const cartContentWrappers = document.querySelectorAll(".ajax_cart_content");
        if(cartContentWrappers){
          cartContentWrappers.forEach(cartContentWrapper => {
            if(cartContentWrapper && !cartContentWrapper.classList.contains('is-atc-user')){
              cartContentWrapper.classList.add('is-atc-user');
            }  
          });
        }
      }
    } else if (this.cart_action == 'mini_cart') {
      this.showMiniCartOnHover();
    }

    $(document).on('click', '.ajax-submit', function (e) {
      e.preventDefault();
      const $addToCartForm = $(this).closest('form');
      window.PXUTheme.jsAjaxCart.addToCart($addToCartForm);

      return false;
    });

    $(document).on('click', '[data-ajax-cart-delete]', function (e) {
      e.preventDefault();
      const lineID = $(this).parents('[data-line-item]').data('line-item');
      window.PXUTheme.jsAjaxCart.removeFromCart(lineID);

      if (window.PXUTheme.jsCart) {
        window.PXUTheme.jsCart.removeFromCart(lineID);
      }

      return false;
    });

    $(document).on('click', '[data-ajax-cart-close]', function (e) {
      e.preventDefault();
      window.PXUTheme.jsAjaxCart.hideDrawer();
      window.PXUTheme.jsAjaxCart.hideMiniCart();

      return false;
    });

  },
  showMiniCartOnHover: function () {
    //console.log('showMiniCartOnHover function called');
    
    const $el = $('[data-ajax-cart-trigger]');

    $el.hover(function() {
      if(window.PXUTheme.theme_settings.header_layout == 'centered' && $('.header-sticky-wrapper').hasClass('is-sticky')) {
        $('.header-sticky-wrapper [data-ajax-cart-trigger]').addClass('show-mini-cart');
      } else {
        $el.addClass('show-mini-cart');
      }
    }, function() {
      $el.removeClass('show-mini-cart');
    });
  },
  hideMiniCart: function () {
    //console.log('hideMiniCart function called');
    if (this.cart_action != 'mini_cart') return false;
    const $el = $('[data-ajax-cart-close]').parents('[data-ajax-cart-trigger]');
    $el.removeClass('show-mini-cart');
  },
  toggleMiniCart: function() {
    //console.log('toggleMiniCart function called');
    const $el = $('.mobile-header [data-ajax-cart-trigger]');

    // Removes url to the cart page so user is not redirected
    $el.attr('href', '#');

    $el.off('touchstart').on('touchstart', function (e) {
      // If user clicks inside the element, do nothing
      if (e.target.closest('[data-ajax-cart-mini_cart]')) {
        return;
      }

      // Loads content into ajaxCart container for mobile header
      // window.PXUTheme.jsAjaxCart.initializeAjaxCartOnMobile();

      // If user clicks outside the element, toggle the mini cart
      $el.toggleClass('show-mini-cart');
    });
  },
  showDrawer: function () {
    //console.log('showDrawer function called');
   /* if (!document.body.classList.contains("atc-user-activate") && !document.body.classList.contains("atc-user-activatev2")) {
      window.location.href = document.location.origin +
        window.Shopify?.routes?.root +
        "cart/";
      return false;
    }*/
    if (this.cart_action != 'drawer') return false;
    this.ajaxCartDrawer.addClass('is-visible');
    $('.ajax-cart__overlay').addClass('is-visible');
    $('html').addClass('cart_popup_visible');
    var $lightbox = $('.quick-shop__lightbox');
    if ($lightbox.hasClass('fancybox-is-open')) {
      // Remove the 'fancybox-is-open' class
      $lightbox.removeClass('fancybox-is-open');

      // Remove the 'display' inline style from the inner popup
      $lightbox.find('.quick-shop__popup').css('display', '');
      var flickityInstance = $lightbox.flickity();
      flickityInstance.resize();
    }
  },
  hideDrawer: function () {
    //console.log('hideDrawer function called');
    if (this.cart_action != 'drawer') return false;
    this.ajaxCartDrawer.removeClass('is-visible');
    $('.ajax-cart__overlay').removeClass('is-visible');
    $('html').removeClass('cart_popup_visible');
  },
  removeFromCart: function (lineID, callback) {
    //console.log('removeFromCart function called');
    $.ajax({
      type: 'POST',
      url: '/cart/change.js',
      data: 'quantity=0&line=' + lineID,
      dataType: 'json',
      success: function (cart) {
        if(rewardBlocks){
      window.PXUTheme.jsAjaxCart.updateGiftProducts(rewardBlocks);
    }
        window.PXUTheme.jsAjaxCart.updateView();
      },
      error: function (XMLHttpRequest, textStatus) {
        var response = eval('(' + XMLHttpRequest.responseText + ')');
        response = response.description;

      }
    });
  },
  initializeAjaxCart: function () {
  //console.log('initializeAjaxCart function called');
    window.PXUTheme.asyncView.load(
      window.PXUTheme.routes.cart_url, // template name
      'ajax', // view name (suffix)
    )
      .done(({ html, options }) => {

        $('[data-ajax-cart-content]').html(html.content);

        // Converting the currencies
        if (window.PXUTheme.currencyConverter) {
          window.PXUTheme.currencyConverter.convertCurrencies();
        }
        if(rewardBlocks){
      window.PXUTheme.jsAjaxCart.updateGiftProducts(rewardBlocks);
    }
        if (crossSellBlock && crossSellBlock.products && crossSellBlock.products.length > 0) {
          const crossSellProducts = crossSellBlock.products;
          renderCrossSellProductElement(crossSellProducts);
        }
        // if(rewardBlocks){
        //   updateMultiRewardsBar(rewardBlocks);
        // }
        window.PXUTheme.jsAjaxCart.updateView();
      })
      .fail(() => {
        // some error handling
      });
  },
  testfunction: function (){
    //console.log('test function called');
  },
  initializeAjaxCartOnMobile: function () {
  //console.log('initializeAjaxCartOnMobile function called');

    this.toggleMiniCart();

    window.PXUTheme.asyncView.load(
      window.PXUTheme.routes.cart_url, // template name
      'ajax', // view name (suffix)
    )
      .done(({ html, options }) => {

        $('.mobile-header [data-ajax-cart-content]').html(html.content);

      })
      .fail(() => {
        // some error handling
      });
  },
 addToCart: function ($addToCartForm) {
  //console.log('addToCart function called');
  const $addToCartBtn = $addToCartForm.find('.button--add-to-cart');

  $addToCartForm.removeClass('shopify-product-form--unselected-error');

  if ($addToCartBtn[0].hasAttribute('data-options-unselected')) {
    const cartWarning = `<p class="cart-warning__message animated bounceIn">${window.PXUTheme.translation.select_variant}</p>`;

    $('.warning').remove();

    $addToCartForm
      .addClass('shopify-product-form--unselected-error')
      .find('.cart-warning')
      .html(cartWarning);

    $addToCartBtn
      .removeAttr('disabled')
      .removeClass('disabled');

    $addToCartBtn.find('.icon')
      .removeClass('zoomOut')
      .addClass('zoomIn');

    $addToCartBtn
      .find('span:not(.icon)')
      .text($addToCartBtn.data('label'))
      .removeClass('zoomOut')
      .addClass('zoomIn');
  } else {
    $.ajax({
      url: '/cart/add.js',
      dataType: 'json',
      cache: false,
      type: 'post',
      data: $addToCartForm.serialize(),
      beforeSend: function () {
        $addToCartBtn
          .attr('disabled', 'disabled')
          .addClass('disabled');

        $addToCartBtn.find('span')
          .removeClass("fadeInDown")
          .addClass('animated zoomOut');
      },
      success: function (product) {
        let $el = $('[data-ajax-cart-trigger]');

        $addToCartBtn
          .find('.checkmark')
          .addClass('checkmark-active');

        function addedToCart() {
          if (!isScreenSizeLarge()) {
            $el = $('.mobile-header [data-ajax-cart-trigger]');
            window.PXUTheme.scrollToTop($el);
          } else {
            $el = $('[data-ajax-cart-trigger]');
          }

          $el.addClass('show-mini-cart');

          $addToCartBtn.find('span')
            .removeClass('fadeInDown');
        }

        // Fetch the updated cart state before proceeding
        fetch('/cart.js')
          .then(response => response.json())
          .then(cart => {
            // Update the cart view first
            window.PXUTheme.jsAjaxCart.updateView();

            // Then check and update gift products
            if (rewardBlocks) {
              window.PXUTheme.jsAjaxCart.updateGiftProducts(rewardBlocks);
            }

            // Complete the UI updates
            window.setTimeout(function () {
              $addToCartBtn
                .removeAttr('disabled')
                .removeClass('disabled');

              $addToCartBtn.find('.checkmark')
                .removeClass('checkmark-active');

              $addToCartBtn.find('.text, .icon')
                .removeClass('zoomOut')
                .addClass('fadeInDown');

              $addToCartBtn.on('webkitAnimationEnd oanimationend msAnimationEnd animationend', addedToCart);

            }, 1000);

            // Show the cart drawer
            window.PXUTheme.jsAjaxCart.showDrawer();

            // Update the main cart form if necessary
            if (window.PXUTheme.jsCart) {
              $.ajax({
                dataType: "html",
                async: false,
                cache: false,
                url: "/cart",
                success: function (html) {
                  const cartForm = $(html).find('.cart__form');
                  $('.cart__form').replaceWith(cartForm);
                }
              });
            }
          })
          .catch(error => {
            console.error('❌ Error fetching cart.js in addToCart:', error);
            $('.ajax_cart_content').removeClass('cart-loading');
          });
      },
      error: function (XMLHttpRequest) {
        let response = eval('(' + XMLHttpRequest.responseText + ')');
        response = response.description;

        const cartWarning = `<p class="cart-warning__message animated bounceIn">${response.replace('All 1 ', 'All ')}</p>`;

        $('.warning').remove();

        $addToCartForm
          .find('.cart-warning')
          .html(cartWarning);

        $addToCartBtn
          .removeAttr('disabled')
          .removeClass('disabled');

        $addToCartBtn.find('.icon')
          .removeClass('zoomOut')
          .addClass('zoomIn');

        $addToCartBtn
          .find('span:not(.icon)')
          .text($addToCartBtn.data('label'))
          .removeClass('zoomOut')
          .addClass('zoomIn');
      }
    });
  }
},
  updateView: function () {
  //console.log('updateView function called');
  /*$('.ajax_cart_content').addClass('cart-loading');*/
  // //console.log("ajax_cart_content added1")
    window.PXUTheme.asyncView.load(
      window.PXUTheme.routes.cart_url, // template name
      'ajax', // view name (suffix)
    )
    .done(({ html, options }) => {

      if (options.item_count > 0) {
        const itemList = $(html.content).find('.ajax-cart__list');
        const cartDetails = $(html.content).find('.ajax-cart__details-wrapper');
        const drawerSections1 = document.querySelectorAll(".custom-cart-drawer1");
        const rewardSections1 = document.querySelectorAll(".discount-reward-bar");
        $('.ajax-cart__list').replaceWith(itemList);
        $('.ajax-cart__details-wrapper').replaceWith(cartDetails);
        $('.ajax-cart__empty-cart-message').addClass('is-hidden');
        $('.ajax-cart__form').removeClass('is-hidden');
        $('[data-ajax-cart-trigger]').addClass('has-cart-count');
        $('[data-bind="itemCount"]').text(options.item_count);
        if(rewardSections1){
          rewardSections1.forEach(rewardSection => {
            if(rewardSection.classList.contains('hide')){
              rewardSection.classList.remove('hide');
            }
          });
        }
        if(drawerSections1){
          drawerSections1.forEach(drawerSection => {
            if(drawerSection.classList.contains('hide')){
              drawerSection.classList.remove('hide');
            }
          });
        }

      } else {
        $('.ajax-cart__empty-cart-message').removeClass('is-hidden');
        $('.ajax-cart__form').addClass('is-hidden');
        $('[data-ajax-cart-trigger]').removeClass('has-cart-count');
        $('[data-bind="itemCount"]').text('0');
        const drawerSections1 = document.querySelectorAll(".custom-cart-drawer1");
        const rewardSections1 = document.querySelectorAll(".discount-reward-bar");
        if(rewardSections1){
          rewardSections1.forEach(rewardSection => {
            if(!rewardSection.classList.contains('hide')){
              rewardSection.classList.add('hide');
            }
          });
        }
        if(drawerSections1){
          drawerSections1.forEach(drawerSection => {
            if(!drawerSection.classList.contains('hide')){
              drawerSection.classList.add('hide');
            }
          });
        }
      }
      
      if(rewardBlocks){
        // updateGiftProducts(rewardBlocks);
        updateMultiRewardsBar(rewardBlocks);
      }

      if (window.PXUTheme.currencyConverter) {
        window.PXUTheme.currencyConverter.convertCurrencies();
      }
      initOrReinitCrossSellSliders();
     /* $('.ajax_cart_content').removeClass('cart-loading');
      //console.log("ajax_cart_content removed2")*/
    })
    .fail(() => {
      // some error handling
    });
  },
updateGiftProducts: async function (rewardBlocks) {
  console.log("Running updateGiftProducts...");
  $('.ajax_cart_content').addClass('cart-loading');

  try {
    const cartResponse = await fetch('/cart.js');
    const cart = await cartResponse.json();
    const cartTotal = cart.original_total_price / 100;           // in dollars
    const items = cart.items;

    // ------------------------------------------------------------------
    // 1. Detect ATC user
    // ------------------------------------------------------------------
   
    const isATCUser = $('body').hasClass('atc-user-activate');
    console.log("ATC user?", isATCUser);

    // ------------------------------------------------------------------
    // 2. Static variant IDs (replace with your real ones)
    // ------------------------------------------------------------------
    const GIFT_ATC_37   = 51953730847059;   // ← put your 37.42 gift variant ID
    const GIFT_ATC_70   = 51953725145427;   // ← put your 69.99 gift variant ID
    const GIFT_NONATC_100 = 52450604810579; // ← put your $100 gift variant ID 

    // ------------------------------------------------------------------
    // 3. Determine which gift the customer qualifies for
    // ------------------------------------------------------------------
    let targetGiftVariantId = null;

    if (isATCUser) {
      if (cartTotal >= 69.99) {
        targetGiftVariantId = GIFT_ATC_70;
      } else if (cartTotal >= 37.42) {
        targetGiftVariantId = GIFT_ATC_37;
      }
  } else {
      if (cartTotal >= 100) {
        targetGiftVariantId = GIFT_NONATC_100;
      }
    }

    console.log("Target gift variant:", targetGiftVariantId, "(total: $"+cartTotal+")");

    // ------------------------------------------------------------------
    // 4. Find all current free gifts in cart (any of the three)
    // ------------------------------------------------------------------
    const FREE_GIFT_IDS = [GIFT_ATC_37, GIFT_ATC_70, GIFT_NONATC_100];

    const currentFreeGifts = items.filter(item =>
      item.properties?.Rewards === 'Free Gift' &&
      FREE_GIFT_IDS.includes(item.variant_id)
    );

    // ------------------------------------------------------------------
    // 5. Remove gifts that are no longer valid
    // ------------------------------------------------------------------
    const removePromises = currentFreeGifts
      .filter(item => item.variant_id !== targetGiftVariantId)
      .map(item => {
        console.log("Removing outdated gift:", item.variant_id);
        return fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: item.key, quantity: 0 })
        });
      });

    if (removePromises.length) {
      await Promise.all(removePromises);
      await new Promise(r => setTimeout(r, 600)); // let Shopify settle
    }

    // ------------------------------------------------------------------
    // 6. Re-fetch cart after removals
    // ------------------------------------------------------------------
    const freshCartResp = await fetch('/cart.js');
    const freshCart = await freshCartResp.json();

    const alreadyHasGift = freshCart.items.some(item =>
      item.variant_id === targetGiftVariantId &&
      item.properties?.Rewards === 'Free Gift'
    );

    // ------------------------------------------------------------------
    // 7. Add the correct gift if missing
    // ------------------------------------------------------------------
    if (targetGiftVariantId && !alreadyHasGift) {
      console.log("Adding free gift:", targetGiftVariantId);
      const addPayload = {
        items: [{
          id: targetGiftVariantId,
          quantity: 1,
          properties: { Rewards: 'Free Gift' }
        }]
      };

      const addResponse = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(addPayload)
      });

      if (!addResponse.ok) {
        console.warn("First add failed, retrying...");
        await new Promise(r => setTimeout(r, 800));
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(addPayload)
        });
      }
      console.log("Free gift added successfully");
    } else if (!targetGiftVariantId && currentFreeGifts.length === 0) {
      console.log("No qualifying amount → no gift needed");
    }

    // ------------------------------------------------------------------
    // 8. Refresh cart UI
    // ------------------------------------------------------------------
    if (window.PXUTheme && window.PXUTheme.jsAjaxCart) {
      window.PXUTheme.jsAjaxCart.updateView();
    }

  } catch (err) {
    console.error("updateGiftProducts error:", err);
  } finally {
    setTimeout(() => $('.ajax_cart_content').removeClass('cart-loading'), 1000);
  }
},
  unload: function ($section) {
  //console.log('unload function called');
    $('.ajax-submit').off();
    $('[data-ajax-cart-delete]').off();
  }
}

function updateMultiRewardsBar() {
  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      const cartTotal = cart.original_total_price / 100;
      //const isATCUser = $('body').hasClass('atc-user-activate');
          const isATCUser = $('body').hasClass('atc-user-activate');
      const barContainer = $('.custom-cart-rewards-bar');
      const CurrencyIcon = barContainer.attr("data-currency");
     
    //  console.log("RewardText", RewardText);
      // Define tiers
      const tiers = isATCUser
        ? [
            { amount: 37.42, label: "37.42 "+CurrencyIcon, reward: "Free Gift A", position: 41 },
            { amount: 69.99, label: "69.99 "+CurrencyIcon, reward: "Free Gift B (Better)" , position: 99 }
          ]
        : [
            { amount: 100, label: "100 "+CurrencyIcon, reward: "Free Gift", position: 99 }
          ];

     
      const fill = barContainer.find('.rewards-progress-fill');
      const messageEl = barContainer.find('.rewards-message');
      const tiersContainer = barContainer.find('.rewards-tiers');

      // Show bar if cart not empty
      if (cart.item_count === 0) {
        barContainer.hide();
        return;
      } else {
        barContainer.show();
      }

      // Find current tier and next one
      let currentTier = null;
      let nextTier = null;

      for (const tier of tiers) {
        if (cartTotal >= tier.amount) {
          currentTier = tier;
        } else {
          nextTier = tier;
          break;
        }
      }

      // Calculate progress (to next or 100%)
      const finalAmount = tiers[tiers.length - 1].amount;
      const progressPercent = Math.min((cartTotal / finalAmount) * 100, 100);

      fill.css('width', progressPercent + '%');

      // Update message
      let message = '';
      if (!nextTier && currentTier) {
        message = `${RewardAfter}`;
      } else if (nextTier) {
        const remaining = (nextTier.amount - cartTotal).toFixed(2);
        message = `${RewardText.replace("AMOUNT", remaining+' '+ CurrencyIcon)}`;
      }

      messageEl.html(message);

      // Generate tier dots + labels
      tiersContainer.empty();
      console.log("Tiers:", tiers);
      console.log("atc check 2", isATCUser)
      tiers.forEach((tier, index) => {
        const isActive = cartTotal >= tier.amount;
        const isLast = index === tiers.length - 1;

        const dot = `
          <div class="rewards-tiers-container rewards-tiers-container-no-icons ${isActive ? 'active' : ''} ${isLast ? 'last' : ''}" style="left:${tier.position}%">
            <div class="rewards-tiers-item-no-icon">
              <span class="icon " data-icon="gift"> 
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><g id="gift"><path d="M94.73,24.85H85.58A12.11,12.11,0,0,0,71.77,5c-2.18,1.21-17,9.64-22.4,17.68C44,14.61,29.15,6.18,27,5A12.11,12.11,0,0,0,13.16,24.85H5.27a2,2,0,0,0-2,2V50.28a2,2,0,0,0,2,2H7.53V95a2,2,0,0,0,2,2H90.47a2,2,0,0,0,2-2V52.28h2.26a2,2,0,0,0,2-2V26.85A2,2,0,0,0,94.73,24.85Zm-21-16.42.13-.08a8.12,8.12,0,0,1,9,13.54l-4.48,3H52.68C56.7,18.79,68.86,11.15,73.78,8.43ZM15.88,21.89A8.12,8.12,0,1,1,24.83,8.35l.13.08C29.88,11.15,42,18.78,46.06,24.85H20.35Zm-8.61,7H48V48.28H7.27Zm4.26,23.43H48V93H11.53ZM88.47,93H52V52.28H88.47Zm4.26-44.72H52V28.85H92.73Z"></path></g></svg>
              </span>
            </div>
            <div class="rewards-tiers-labels-item"><span class="rewards-tiers-labels-item-label">${tier.label}</span></div>
          </div>
        `;
        tiersContainer.append(dot);
      });
    })
    .catch(err => console.error("Progress bar update failed:", err));
}

function setCookie(name, value, days) {
  const date = new Date();
  date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
  const expires = "expires=" + date.toUTCString();
  document.cookie = name + "=" + value + ";" + expires + ";path=/";
}
function getCookie(name) {
  const nameEQ = name + "=";
  const ca = document.cookie.split(';');
  for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}
function renderCrossSellProductElement(crossSellProducts) {
  //console.log('renderCrossSellProductElement function called');
  // console.log(crossSellProducts);
  const crossSellContainers = document.querySelectorAll(".cross-sell-products-container");

  if (crossSellContainers.length > 0) {

    const productWrapper = document.createElement('div');
    productWrapper.classList.add('cross-sell-product-wrapper');
    
    // Start slider container
    const sliderContainer = document.createElement('div');
    sliderContainer.classList.add('cross-sell-slider');

    // Render all cross-sell products in the slider
    crossSellProducts.forEach(product => {
      const sliderElement = document.createElement('div');
      sliderElement.classList.add('slick_slide');
      const productElement = document.createElement('div');
      productElement.classList.add('cross-sell-product');
      
      productElement.innerHTML = `
        <img src="${product.image}" alt="${product.title}" class="cross-sell-product-image">
        <div class="cross-sell-product_content">
          <h4 class="cross-sell-product-title">${product.title}</h4>
          <div class="cross-sell-price-with-cta">
            <p class="cross-sell-product-price">${product.price}</p>
            <button class="add-to-cart-cross-sell-button" data-variant-id="${product.variantId}">
              ${window.PXUTheme.translation.addToCart}
            </button>
          </div>
        </div>
      `;
      
      sliderElement.appendChild(productElement);
      sliderContainer.appendChild(sliderElement);
    });

    // Append the slider container to the wrapper
    productWrapper.appendChild(sliderContainer);

    crossSellContainers.forEach(container => {
      container.appendChild(productWrapper.cloneNode(true));
    });

    // 🔹 Init/re-init slick after appending
    initOrReinitCrossSellSliders();

    // Add event listeners for "Add to Cart" buttons
    const addToCartCrossSellButtons = document.querySelectorAll('.add-to-cart-cross-sell-button');
    addToCartCrossSellButtons.forEach(button => {
      button.addEventListener('click', function (e) {
        e.preventDefault();
        const productVariantId = e.target.getAttribute('data-variant-id');
        if (productVariantId) {
          addToCartCrossSell(productVariantId);
        }
      });
    });
  } else {
    //console.log('crossSellContainers not found!');
  }
}
function initOrReinitCrossSellSliders() {
    //console.log('initOrReinitCrossSellSliders function called');
  const $sliders = jQuery('.cross-sell-slider');

  $sliders.each(function () {
    const $slider = jQuery(this);
    // If already initialized, destroy first
    if ($slider.hasClass('slick-initialized')) {
      $slider.slick('unslick');
    }
    // (Re)initialize slick
    $slider.slick({
      dots: false,
      infinite: false,
      speed: 300,
      slidesToShow: 1,
      slidesToScroll: 1,
      prevArrow: '<button type="button" class="slick-prev">Previous</button>',
      nextArrow: '<button type="button" class="slick-next">Next</button>',
      responsive: [
        {
          breakpoint: 600,
          settings: { slidesToShow: 1, slidesToScroll: 1 }
        },
        {
          breakpoint: 480,
          settings: { slidesToShow: 1, slidesToScroll: 1 }
        }
      ]
    });
  });
}

function addToCartCrossSell(productVariantId) {
  //console.log('addToCartCrossSell function called');
   $('.ajax_cart_content').addClass('cart-loading');
  const formData = {
    items: [{
      id: productVariantId,  // Add the variant ID
      quantity: 1      // Quantity to add (adjust as needed)
    }]
  };
  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  })
    .then(response => response.json())
    .then(data => {
      //console.log('product added');
      if(rewardBlocks){
      window.PXUTheme.jsAjaxCart.updateGiftProducts(rewardBlocks);
    }
      window.PXUTheme.jsAjaxCart.updateView();
       $('.ajax_cart_content').removeClass('cart-loading');

    })
    .catch(error => {
      console.error('Error adding product to cart:', error);
    });
}
function getActUserCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
}


/******/ })()
;